import { PropsWithChildren } from "react";
import { m } from "framer-motion";

import Header from "../components/header";
import Footer from "../components/common/Footer";

type LayoutProps = PropsWithChildren;

const BasicLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="w-full flex flex-col bg-gray-100">
      <Header />
      <m.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{
          opacity: 0,
          transition: { duration: 0.3 },
        }}
        transition={{ duration: 0.4 }}
        className="flex flex-col text-center bg-header-pattern bg-repeat overflow-x-hidden relative z-10 pt-14"
        style={{ minHeight: "100vh" }}
      >
        <div className="grow">{children}</div>
        <Footer />
      </m.main>
    </div>
  );
};

export default BasicLayout;
